import { classes } from "lib/actions/util";
import { useEffect } from "react";
import { useUploadPreprocessor } from "../UploadPreprocessorContext";

const UploadIssueTypeSelection = () => {
  const { uploadIssues, selectedUploadIssueType, setSelectedUploadIssueType } =
    useUploadPreprocessor();

  const tabNames = uploadIssues
    .map((x) => x.type)
    .filter((x, i, a) => a.indexOf(x) === i);

  useEffect(() => {
    if (!selectedUploadIssueType) {
      setSelectedUploadIssueType(tabNames[0]);
    }
  }, [uploadIssues]);

  return (
    <div
      className={classes(
        "flex w-full items-start",
        tabNames.length > 1 ? "justify-center" : "justify-start",
      )}
    >
      {tabNames.map((tabName) => {
        const issueCountRaw = uploadIssues
          .map((x) => x.type)
          .filter((x) => x === tabName).length;
        const issueCountDisplay =
          issueCountRaw < 10 ? "0" + issueCountRaw : issueCountRaw;

        return (
          <button
            key={tabName}
            onClick={() => setSelectedUploadIssueType(tabName)}
            className={classes(
              "flex flex-1 items-center justify-center space-x-2 border-b-2 px-8 pb-3 pt-1",
              selectedUploadIssueType === tabName
                ? "border-black"
                : "border-gray-300",
            )}
          >
            <span className="font-bold">{tabName}</span>
            <span className="bg-black p-1 font-mono text-xs text-white">
              {issueCountDisplay}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default UploadIssueTypeSelection;
